import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=574c4f67&scoped=true"
import script from "./Events.vue?vue&type=script&lang=ts"
export * from "./Events.vue?vue&type=script&lang=ts"
import style0 from "./Events.vue?vue&type=style&index=0&id=574c4f67&prod&lang=scss&scoped=true"
import style1 from "./Events.vue?vue&type=style&index=1&id=574c4f67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574c4f67",
  null
  
)

export default component.exports